import {
  PAYMENTS_AUTHORIZE_FAILURE,
  PAYMENTS_AUTHORIZE_REQUEST,
  PAYMENTS_AUTHORIZE_SUCCESS,
  PAYMENTS_CLEAR_ERROR,
  PAYMENTS_CREATE_METHOD_FAILURE,
  PAYMENTS_CREATE_METHOD_REQUEST,
  PAYMENTS_CREATE_METHOD_SUCCESS,
  PAYMENTS_DELETE_METHOD_FAILURE,
  PAYMENTS_DELETE_METHOD_REQUEST,
  PAYMENTS_DELETE_METHOD_SUCCESS,
  PAYMENTS_METHODS_FAILURE,
  PAYMENTS_METHODS_REQUEST,
  PAYMENTS_METHODS_SUCCESS,
  PAYMENTS_METHOD_PLANS_FAILURE,
  PAYMENTS_METHOD_PLANS_REQUEST,
  PAYMENTS_METHOD_PLANS_SUCCESS,
  PAYMENTS_METHOD_PLAN_CREATE_FAILURE,
  PAYMENTS_METHOD_PLAN_CREATE_REQUEST,
  PAYMENTS_METHOD_PLAN_CREATE_SUCCESS,
  PAYMENTS_METHOD_PLAN_DELETE_FAILURE,
  PAYMENTS_METHOD_PLAN_DELETE_REQUEST,
  PAYMENTS_METHOD_PLAN_DELETE_SUCCESS,
  PAYMENTS_METHOD_PLAN_UPDATE_FAILURE,
  PAYMENTS_METHOD_PLAN_UPDATE_REQUEST,
  PAYMENTS_METHOD_PLAN_UPDATE_SUCCESS,
  PAYMENTS_PROVIDERS_FAILURE,
  PAYMENTS_PROVIDERS_REQUEST,
  PAYMENTS_PROVIDERS_SUCCESS,
  PAYMENTS_SET_PRIMARY_FAILURE,
  PAYMENTS_SET_PRIMARY_REQUEST,
  PAYMENTS_SET_PRIMARY_SUCCESS,
  PAYMENTS_UPDATE_METHOD_FAILURE,
  PAYMENTS_UPDATE_METHOD_REQUEST,
  PAYMENTS_UPDATE_METHOD_SUCCESS
} from '../../../types/paymentsTypes';

export const PAYMENT_ACTIONS = {
  PAYMENTS_PROVIDERS_REQUEST,
  PAYMENTS_PROVIDERS_SUCCESS,
  PAYMENTS_PROVIDERS_FAILURE,
  PAYMENTS_METHODS_REQUEST,
  PAYMENTS_METHODS_SUCCESS,
  PAYMENTS_METHODS_FAILURE,
  PAYMENTS_CREATE_METHOD_REQUEST,
  PAYMENTS_CREATE_METHOD_SUCCESS,
  PAYMENTS_CREATE_METHOD_FAILURE,
  PAYMENTS_UPDATE_METHOD_REQUEST,
  PAYMENTS_UPDATE_METHOD_SUCCESS,
  PAYMENTS_UPDATE_METHOD_FAILURE,
  PAYMENTS_SET_PRIMARY_REQUEST,
  PAYMENTS_SET_PRIMARY_SUCCESS,
  PAYMENTS_SET_PRIMARY_FAILURE,
  PAYMENTS_AUTHORIZE_REQUEST,
  PAYMENTS_AUTHORIZE_SUCCESS,
  PAYMENTS_AUTHORIZE_FAILURE,
  PAYMENTS_DELETE_METHOD_REQUEST,
  PAYMENTS_DELETE_METHOD_SUCCESS,
  PAYMENTS_DELETE_METHOD_FAILURE,
  PAYMENTS_METHOD_PLANS_REQUEST,
  PAYMENTS_METHOD_PLANS_SUCCESS,
  PAYMENTS_METHOD_PLANS_FAILURE,
  PAYMENTS_METHOD_PLAN_CREATE_REQUEST,
  PAYMENTS_METHOD_PLAN_CREATE_SUCCESS,
  PAYMENTS_METHOD_PLAN_CREATE_FAILURE,
  PAYMENTS_METHOD_PLAN_UPDATE_REQUEST,
  PAYMENTS_METHOD_PLAN_UPDATE_SUCCESS,
  PAYMENTS_METHOD_PLAN_UPDATE_FAILURE,
  PAYMENTS_METHOD_PLAN_DELETE_REQUEST,
  PAYMENTS_METHOD_PLAN_DELETE_SUCCESS,
  PAYMENTS_METHOD_PLAN_DELETE_FAILURE,
  PAYMENTS_CLEAR_ERROR
};
